module.exports = __webpack_public_path__ + "static/media/daylytes_home.7d982863.png";